<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="custom-control custom-checkbox mb-2"
            *ngIf="authSerivce.isEndpointStatus('POST.Writing.ExcelCompanyUpload')">
            <input type="checkbox" class="custom-control-input" id="customCheck1" [checked]="isAdvancedChange"
                (change)="toggleAdvancedUpload($event)" />
            <label class="custom-control-label" for="customCheck1">Excel ile yükleme</label>
        </div>

        <div id="stepper1" class="bs-stepper horizontal-wizard-example">
            <div class="bs-stepper-header">
                <div class="step" data-target="#company-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">1</span>
                        <span class="bs-stepper-label">
                            <span class="bs-stepper-title">Firma Bilgileri</span>
                            <span class="bs-stepper-subtitle">Firma bilgilerini girin</span>
                        </span>
                    </button>
                </div>
                <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                <div class="step" data-target="#special-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">2</span>
                        <span class="bs-stepper-label">
                            <span class="bs-stepper-title">Özel Bilgiler</span>
                            <span class="bs-stepper-subtitle">Özel bilgileri girin</span>
                        </span>
                    </button>
                </div>
                <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                <div class="step" data-target="#other-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">3</span>
                        <span class="bs-stepper-label">
                            <span class="bs-stepper-title">Diğer Bilgiler</span>
                            <span class="bs-stepper-subtitle">Diğer bilgileri girin</span>
                        </span>
                    </button>
                </div>
            </div>

            <div class="bs-stepper-content">
                <form [formGroup]="companyForm" (ngSubmit)="onSubmit()" (submit)="preventSubmit($event)">
                    <!-- Firma Bilgileri Adımı -->
                    <div id="company-info" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Firma Bilgileri</h5>
                            <small class="text-muted">Firma bilgilerini girin.</small>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="companyName">Firma Adı</label>
                                <input formControlName="companyName" type="text" id="companyName" class="form-control"
                                    placeholder="Firma Adı" oninput="this.value = this.value.toUpperCase()" />
                                <div *ngIf="companyForm.get('companyName').hasError('required')">
                                    <small class="text-danger">Firma adı zorunludur.</small>
                                </div>
                                <div *ngIf="companyForm.get('companyName').hasError('maxlength')">
                                    <small class="text-danger">Firma Adı en fazla 200 karakter uzunluğunda
                                        olabilir.</small>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="mail">E-posta</label>
                                <input formControlName="mail" type="email" id="mail" class="form-control"
                                    placeholder="E-posta" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="phoneNumber">Telefon</label>
                                <input formControlName="phoneNumber" type="text" id="phoneNumber" class="form-control"
                                    placeholder="Telefon" mask="(000) 000 00 00" />
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="phoneNumber2">Telefon 2</label>
                                <input formControlName="phoneNumber2" type="text" id="phoneNumber2" class="form-control"
                                    placeholder="Telefon 2" mask="(000) 000 00 00" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="form-label" for="address">Adres</label>
                                <input formControlName="address" type="text" id="address" class="form-control"
                                    placeholder="Adres" oninput="this.value = this.value.toUpperCase()" />
                                <div *ngIf="companyForm.get('address').hasError('maxlength')">
                                    <small class="text-danger">Adres en fazla 200 karakter uzunluğunda olabilir.</small>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-outline-secondary btn-prev" disabled>
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Önceki</span>
                            </button>
                            <button type="button" class="btn btn-primary btn-next"
                                (click)="horizontalWizardStepperNext('company-info')">
                                <span class="align-middle d-sm-inline-block d-none">Sonraki</span>
                                <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Özel Bilgiler Adımı -->
                    <div id="special-info" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Özel Bilgiler</h5>
                            <small>Özel bilgileri girin.</small>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="taxNumber">Vergi Numarası</label>
                                <input formControlName="taxNumber" type="text" id="taxNumber" class="form-control"
                                    placeholder="Vergi Numarası" maxlength="11" />
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="taxAdministration">Vergi Dairesi</label>
                                <input formControlName="taxAdministration" type="text" id="taxAdministration"
                                    oninput="this.value = this.value.toUpperCase()" class="form-control"
                                    placeholder="Vergi Dairesi" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="futuresDay">Vadeli Gün</label>
                                <input formControlName="futuresDay" type="number" id="futuresDay" class="form-control"
                                    placeholder="Vadeli Gün"
                                    onKeyUp="if(this.value>99){this.value='99';}else if(this.value<0){this.value='0';}" />
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="discountRate">İndirim Oranı</label>
                                <input formControlName="discountRate" type="number" id="discountRate"
                                    class="form-control" placeholder="İndirim Oranı"
                                    onKeyUp="if(this.value>99){this.value='99';}else if(this.value<0){this.value='0';}" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="categoryId">Kategori</label>
                                <select formControlName="categoryId" class="form-control">
                                    <option *ngFor="let item of itemControllerTypes" [value]="item.id">
                                        {{item.categoryName}}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="currencyId">Para Birimi</label>
                                <select formControlName="currencyId" class="form-control">
                                    <option *ngFor="let item of currencies" [value]="item.id">
                                        {{item.currencyName}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="categoryId">İl</label>
                                <select class="form-control" (change)="onProvinceChange($event)">
                                    <option value="" disabled selected>İl Seçiniz</option>
                                    <option *ngFor="let item of provinces" [value]="item.id">
                                        {{item.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="districtId">İlçe</label>
                                <select class="form-control" formControlName="districtId">
                                    <option value="" disabled selected>İlçe Seçiniz</option>
                                    <option *ngFor="let item of districts" [value]="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-primary btn-prev"
                                (click)="horizontalWizardStepperPrevious()">
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Önceki</span>
                            </button>
                            <button type="button" class="btn btn-primary btn-next"
                                (click)="horizontalWizardStepperNext('special-info')">
                                <span class="align-middle d-sm-inline-block d-none">Sonraki</span>
                                <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Diğer Bilgiler Adımı -->
                    <div id="other-info" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Diğer Bilgiler</h5>
                            <small>Diğer bilgileri girin.</small>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-5 ml-1 mt-2">
                                <input type="file" accept=".png, .jpeg, .jpg" class="custom-file-input" id="customFile"
                                    (change)="onFileSelected($event)" />
                                <label class="custom-file-label" for="customFile">{{ fileName }}</label>
                            </div>
                            <div class="form-group col-md-12">
                                <label class="form-label" for="description">Açıklama</label>
                                <input formControlName="description" type="text" id="description" class="form-control"
                                    placeholder="Açıklama" />
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="labelInput">Etiketler</label>
                            <input id="labelInput" type="text" class="form-control" (keydown)="addLabel($event)"
                                placeholder="Etiket ekleyin ve Enter'a basın" />
                            <div class="chip-container">
                                <div *ngFor="let label of labels" class="chip">
                                    {{ label }}
                                    <button class="close" (click)="removeLabel(label)">×</button>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-primary btn-prev"
                                (click)="horizontalWizardStepperPrevious()">
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Önceki</span>
                            </button>
                            <button type="submit" class="btn btn-success btn-next" [disabled]="!companyForm.valid"
                                *ngIf="authSerivce.isEndpointStatus('POST.Writing.CreateCompany')">
                                <span class="align-middle d-sm-inline-block d-none">Kaydet</span>
                                <i data-feather="check" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div *ngIf="isAdvancedChange" class="card mt-2">
            <div class="form-group">
                <div class="col-12 d-flex justify-content-between">
                    <div class="col-4">
                        <label for="basicInputFile">Firma Yükle</label>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile" (change)="onFileChange($event)"
                                accept=".xlsx, .xls" #fileInput />
                            <label class="custom-file-label" for="customFile">Excel dosyası seçiniz</label>
                        </div>
                    </div>
                    <div class="col-4 mt-2 d-flex justify-content-between">
                        <button type="button" class="btn btn-outline-danger" rippleEffect
                            (click)="resetFileInput(fileInput)">Dosyayı sil</button>

                        <a href="assets/excels/ornek_firma.xlsx" download="Firma_Listesi_Şablonu.xlsx"
                            class="btn btn-outline-info" rippleEffect>
                            <span [data-feather]="'arrow-down'" [class]="'mr-25'"></span>
                            Şablon
                        </a>
                    </div>
                </div>
            </div>


            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Firma Adı</th>
                            <th>Mail</th>
                            <th>Tel No</th>
                            <th>Adres</th>
                            <th>Vergi Daires</th>
                            <th>Vergi No</th>
                            <th>Para Birimi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of companies; let i = index">
                            <td>{{i + 1}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.mail}}</td>
                            <td>{{item.phoneNumber}}</td>
                            <td>{{item.address}}</td>
                            <td>{{item.taxAdministration}}</td>
                            <td>{{item.TaxNumber}}</td>
                            <td>{{item.currency?.currencyName}}</td>
                        </tr>
                    </tbody>
                </table>
                <button type="button" class="btn btn-success d-flex ml-1 mt-2 mb-2" rippleEffect
                    [disabled]="!isCompaniesValid || !allCompaniesValid" (click)="saveCompanies()">Kaydet</button>
            </div>
        </div>

    </div>
</div>